<script lang="ts" setup>
//import { DateTime } from "luxon/src/luxon";
import { useI18n } from "vue-i18n";
import { DateTime } from "luxon";

const config = useRuntimeConfig()
const router = useRouter()
const i18n = useI18n()
const api = useStoryblokApi();
const path = router.currentRoute.value.path

const isGermanSlug = path.startsWith('/de')
const slug = isGermanSlug ? path.replace('/de', '') : path;

//console.log('SLUG::',slug)
const lang = i18n.locale.value

const {data} = await api.get(`cdn/stories${slug}`, { 
	version: config.public.blog.mode, 
	resolve_relations: 'category,author,reviewer',
	language: lang === 'en' ? 'default' : lang 
}) 

const story = data.story
const deSlug = story.translated_slugs.filter((x:any)=>x.lang === 'de')[0].path.split('/')[1]

defineI18nRoute({
  paths: {
    en: '/posts/'+story.slug,
   	de: '/posts/'+deSlug,
  },
})

/*
definePageMeta({
  nuxtI18n: {
    en: { id: story.slug },
    de: { id: deSlug }
  }
})*/

//console.log('data::', data)
//console.log("rel::", data.rels)

const author = data.rels.find((x:any)=>x.uuid === story.content.author)
const reviewer = data.rels.find((x:any)=>x.uuid === story.content.reviewer)
const categories: Array<any> = []

for(const id of story.content.category){
	if(id !== config.public.blog.categoryUUID){
		const category = data.rels.find((x:any)=>x.uuid === id)
		if(category){
			categories.push(category)
		}
	}
}

const enPath = '/posts/'+story.slug
const dePath = '/de/posts/'+deSlug

//reviewer
//console.log('slug 1:', slug)
//console.log('author::', author)

const title = story.content.metatags.title?.length ? story.content.metatags.title : story.content.title
console.log('title::', title)
const description = story.content.metatags.description.length ? story.content.metatags.description : stripHtml( renderRichText(story.content.copy) )
console.log('description::', description)
console.log('keywords::', story.content.keywords)

const image = story.content.image.filename+'/m/'
const dimension = story.content.image.filename ? imageDimension(story.content.image.filename) : undefined
const imgType = imageType(story.content.image.filename?.toString())
const imageAlt = story.content.image.alt
//const dt = DateTime.fromISO(story.published_at)
// /<meta name="author" content="John Doe">

// HOWTO:: https://v8.i18n.nuxtjs.org/guide/seo

const baseUrl = config.public.hostname
//const deSlug = (props.story as any).translated_slugs.filter((x:any)=>x.lang === 'de')[0].path.split('/')[1]

const i18nHead = useLocaleHead({
  addSeoAttributes: true,
})

const enUrl = baseUrl+'/posts/'+story.slug
const deUrl = baseUrl+'/de/posts/'+deSlug
const url = baseUrl+router.currentRoute.value.fullPath
const link = [
			{ rel: 'alternate', href: enUrl, hreflang: 'en' },
			{ rel: 'alternate', href: enUrl, hreflang: 'en-US' },
			{ rel: 'alternate', href: enUrl, hreflang: 'x-default' },
			{ rel: 'alternate', href: deUrl, hreflang: 'de' },
			{ rel: 'alternate', href: deUrl, hreflang: 'de-DE' },
			{ rel: 'canonical', href: url},
]

console.log('categories filtered::', categories)		 
console.log('i18nHead.meta::', i18nHead.value.meta)
const dt = DateTime.fromISO(story.published_at)

useServerSeoMeta({
    ogTitle: () => title,
    title: () => title,
    description: () => description,
		keywords: () => story.content.keywords,
		author: () => author?.name ?? 'Smoxy',
    ogDescription: () => description,
    ogImage: () => image,
    ogImageUrl: () => image,
		ogImageAlt: () => imageAlt,
		ogImageType: () => imgType,
		ogImageWidth: () => dimension?.width ?? undefined,
		ogImageHeight: () => dimension?.height ?? undefined,
		ogLocale: () => i18nHead.value.htmlAttrs!.lang,
		ogType: () => 'article',
		ogUrl: () => url,
    twitterCard: () => 'summary_large_image',
    twitterTitle: () => title,
    twitterDescription: () => description,
    twitterImage: () => image,
		robots: () => 'index,follow',
		revised: () => dt.toISODate(),
		links: () => link,
  })
</script>
<template>
	<div class="overflow-x-hidden bg-newdark-800">
		<Header theme="dark" />
		<StoryblokComponent v-if="story" :blok="story.content" :story="story" :author="author" :reviewer="reviewer" :categories="categories"   />
		<Footer theme="dark" :en-slug="enPath" :de-slug="dePath" />
	</div>
</template>
